var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstructionBlack24Dp1X(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B272779B-26E6-43FB-9110-F4A2C79DDDF1@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CondoGo:-Icon-Library",
    transform: "translate(-36.000000, -645.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "construction_black_24dp",
    transform: "translate(36.000000, 645.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(15.841445, 15.109317) rotate(-45.000000) translate(-15.841445, -15.109317) ",
    x: 14.3414594,
    y: 10.8693577,
    width: 2.99997123,
    height: 8.47991868
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,8 C17.43,8 19,6.43 19,4.5 C19,3.92 18.84,3.38 18.59,2.9 L15.89,5.6 L14.4,4.11 L17.1,1.41 C16.62,1.16 16.08,1 15.5,1 C13.57,1 12,2.57 12,4.5 C12,4.91 12.08,5.3 12.21,5.66 L10.36,7.51 L8.58,5.73 L9.29,5.02 L7.88,3.61 L10,1.49 C8.83,0.32 6.93,0.32 5.76,1.49 L2.22,5.03 L3.63,6.44 L0.81,6.44 L0.1,7.15 L3.64,10.69 L4.35,9.98 L4.35,7.15 L5.76,8.56 L6.47,7.85 L8.25,9.63 L0.84,17.04 L2.96,19.16 L14.34,7.79 C14.7,7.92 15.09,8 15.5,8 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionBlack24Dp1X);
export default __webpack_public_path__ + "static/media/construction_black_24dp@1x.2aa1816c0d0ea8076fde9f37c3a21c46.svg";
export { ForwardRef as ReactComponent };